export interface Location {
  id: number;
  name: string;
  locationTypeId: number;
  latitude: number,
  longitude: number,
}

export interface LocationType {
  "id": number,
  "name": string,
  "image": string
}

export interface LocationCreate {
  "name": string,
  "locationTypeId": number
  "latitude": number
  "longitude":number
}